import CompanyDetails from './CompanyDetails';

export default CompanyDetails;
